<template>
  <button class="containerPillClick mb-2">
    <div class="containerTitleAndButtonsList">
      <div class="containerTitleAndLoader">
        <div class="containerTitleList">
          <span class="subtitleList--text">CD: {{ data.course.code }}</span>
          <span class="titleList--text"> {{ data.course.name || "Titulo no definido" }}</span>
        </div>
        <div class="containerBtnsList">
          <button 
            class="containerBtn--seeRigthNow"
            :class="{ 'btn-expired': isCourseExpired }"
            :disabled="isCourseExpired"
            @click="!isCourseExpired && HandlerShowContent(data)"
          >
            <v-icon class="mr-2" color="white">
              {{ isCourseExpired ? 'mdi-clock-alert-outline' : 'mdi-view-compact' }}
            </v-icon>
            <span>{{ isCourseExpired ? 'Curso expirado' : 'Ver Contenido' }}</span>
          </button>
        </div>
      </div>
      <div class="containerPathGone--loader">
        <div class="containerPathGone--loader--titles">
          <span class="containerPathGone--loader--titles--yourPath">Progreso {{ data.current_progress }}%</span>
        </div>
        <loader-unicolor :percentage="data.current_progress" />
      </div>
    </div>
  </button>
</template>

<script>
import LoaderUnicolor from "../../Dashboard/LoaderUniColorNew.vue";

export default {
  components: {
    "loader-unicolor": LoaderUnicolor,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    icon: {
      type: String,
      default: "",
    },
    levelCode: {
      type: String,
      default: "basico",
    },
    favoriteDefault: {
      type: Boolean,
      default: false,
    },
    hiddenFav: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFavorite: false,
    };
  },
  computed: {
    isCourseExpired() {
      // Verificar si el curso tiene schedule y si está expirado
      return this.data.schedule?.is_expired === true;
    }
  },
  mounted() {
    this.isFavorite = this.favoriteDefault;
  },
  methods: {
  
     async HandlerShowContent(data) {
     
      const query =  data.schedule_id ? 
       { module_id: data.course_id, level_id: this.levelCode, schedule_id: data.schedule_id, course_in_progress: false } : 
       { module_id: data.course_id, level_id: this.levelCode, course_in_progress: false  };
      this.$router.push({
        name: "profileNew",
        query: query,
      });
    },
    cutShortString(string, longitud = 75) {
      if (string.length > longitud) {
        string = string.substring(0, longitud);
        string += "...";
      }
      return string;
    },
  },
};
</script>

<style scoped>
@media (max-width: 768px) {
  .containerPillClick_img {
    margin-top: 1rem !important;
  }

   .containerPillClick {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .containerTitleAndButtonsList {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .containerBtnsList {
    display: flex !important;
    /* flex-direction: column; */
    gap: 1rem !important;
  }
  .titleList--text,
  .subtitleList--text {
    max-width: 215px !important;
  }
}
.favoriteClass {
  background-color: #f1416c !important;
}
.imgContainTT {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  width: 145px;
  height: 145px;
  /* border-radius: 12px; */
}
.white-10 {
  background-color: #a4a4a438;
}

.circleIcon {
  width: 35px;
  height: 35px;
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  /* overflow: hidden; */
  border-radius: 100px;
  padding: 5px;
  justify-content: center;
}

.containerIconBtn--seeRigthNow {
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.containerBtn--seeRigthNow {
  background: #0076ff 0% 0% no-repeat padding-box;
  border-radius: 32px;
  /* height: 36px; */
  text-align: center;
  font: normal normal normal 13px/30px Poppins;
  letter-spacing: 0px;
  color: #ffffff;
  padding: 9px 20.5px 8px 36.5px;
  padding: 9px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.containerBtn--seeRigthNow.btn-expired {
  background: #0076ff 0% 0% no-repeat padding-box;
  cursor: not-allowed;
  opacity: 0.4;
}

.containerBtn--seeRigthNow.btn-expired:hover {
  background: #0076ff 0% 0% no-repeat padding-box;
  opacity: 0.4;
}

.containerBtnsList {
  display: flex;
  align-items: center;
  /* margin-left: 2rem; */
}

.subtitleList--text {
  text-align: left;
  font: normal normal 300 12px Poppins;
  letter-spacing: 0px;
  color: #6f7b87;
}
.titleList--text {
    text-align: left;
    font: normal normal bold 15px/23px Poppins;
    letter-spacing: 0px;
    color: #101820;
    padding-bottom: 10px;
}

.containerTitleList {
  display: flex;
  flex-direction: column;
  text-align: left;
  /* margin-left: 2rem; */
}
.containerPillClick {
  width: 100%;
  /* height: 145px; */
  display: flex;
  /* background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box; */
  border: 1px solid var(--unnamed-color-dfdfdf);
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #dfdfdf;
  border-radius: 8px;
  opacity: 1;
}
.containerTitleAndButtonsList {
  display: flex;
  flex-direction: column;
  padding: 21px;
  width: 100%;
  gap: 0rem;
}

.containerPillClick_img {
  border-radius: 8px 0px 0px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 165px;
  height: 145px;
}

.containerTitleAndLoader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.containerPathGone--loader {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.containerPathGone--loader--titles {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.2rem;
}

.containerPathGone--loader--titles--yourPath {
  text-align: right;
  font: normal normal normal 12px/18px Poppins;
  letter-spacing: 0px;
  color: #101820;
}

.colorBlue {
  color: #0076ff;
}

.fontBold {
  font-weight: bold !important;
}
</style>
